import axiosInstance from "./axiosInstance";

export const fetchProductList = async () => {
  const res = await axiosInstance.get('/order/products/active');
  return res?.data?.data;
};

export const saveProductAPI = async (data) => {
  const res = await axiosInstance.post('/order/products/insert_product', data);
  return res.data;
};

export const uploadProductImage = async (file) => {
  const formData = new FormData();
  formData.append("file", file); 

  const res = await axiosInstance.post("/master/ImageUpload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};


export const fetchCategoryList = async () => {
  const res = await axiosInstance.get('/order/products/category');
  return res?.data?.data;
};

export const updateProductAPI = async (data) => {
  const res = await axiosInstance.post('/order/products/update_product', data);
  return res.data;
};